<template>
  <b-modal ref="modal" visible size="lg" :hide-footer="true" title="Locatie gescand" @hidden="$emit('close')">
      <div class="block block-bordered">
        <div class="block-header block-header-default">
            <h1>Locatie gescand: {{location}} <h4 style = "display: block; margin-top: px;">Aan welke locatie wil je het toevoegen</h4></h1>
        </div>
        <div class="block-content">
            <button @click="update('location')" type="submit" class="btn btn-primary btn-lg" style="margin-right: 25px;">Standaard locatie</button>
            <button @click="update('overstock_location')" type="submit" class="btn btn-primary btn-lg" style="margin-right: 25px;">Locatie overvoorraad</button>
            <button @click="closeModal" type="submit" class="btn btn-danger btn-lg">Annuleren</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import http from '../utils/http'
export default {
  props: {
    location: String,
    productId: Number
  },
  methods: {
    update (field) {
      const data = {
        [field]: this.location
      }
      return http.patch(`/products/${this.productId}`, data)
      .then((result) => {
        this.closeModal()
        this.$swal('Hoera 😊', `De locatie van het product is succevol bijgewerkt.`, 'success')
      })
        .catch(() => {
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het updaten van de locatie. Probeer het opnieuw.`, 'error')
        })
    },
    closeModal () {
      this.$refs.modal.hide()
    }
  }
}
</script>




// WEBPACK FOOTER //
// UpdateLocationModal.vue?6f777788